import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Ourcompany() {
    const navigate = useNavigate()
    return (
        <>
            {/* Header Section */}
            <section className="info-header">
                <Container>
                    <Row>
                        <Col sm={12} md={12} lg={6}>
                            <h6 style={{ color: '#1dc2ef' }}>OUR COMPANY</h6>
                            <h1>Simplifying IT, <br/>Amplifying Success!</h1>
                        </Col>
                        <Col sm={12} md={12} lg={6}>
                            <p>
                                At Digisoft, we're not just a company; we're a team of passionate IT experts who care about your business. We understand that technology can be overwhelming. That's why we take the time to listen to your needs and tailor our solutions to your specific requirements. With a personal approach, we'll ensure that your IT journey is smooth and stress-free.
                            </p>
                        </Col>
                    </Row>


                </Container>
            </section>

            {/* Cards Section */}
            <div className="infocard-bg">
                <section className="info-cards">
                    <Container>
                        <Row>
                            {/* Card 1 */}
                            <Col sm={12} md={12} lg={4} className="company-infosys">
                                <div className="info-card" onClick={() => navigate("/it-strategy-consulting")} style={{ cursor: "pointer" }}>
                                    <img src="images/c1.jpg" alt="Service 1" />
                                    <div className="info-card-text">
                                        {/* <h6>Our services</h6> */}
                                        <h3>IT Strategy &<br/> Consulting</h3>
                                    </div>
                                </div>
                            </Col>

                            {/* Card 2 */}
                            <Col sm={12} md={12} lg={4} className="company-infosys">
                                <div className="info-card" onClick={() => navigate("/it-staffing-resource")} style={{ cursor: "pointer" }}>
                                    <img src="images/staff.jpg" alt="Service 2" />
                                    <div className="info-card-text">
                                        {/* <h6>Our expertise</h6> */}
                                        <h3>IT Staffing &<br/> Resource Augmentation</h3>
                                    </div>
                                </div>
                            </Col>

                            {/* Card 3 */}
                            <Col sm={12} md={12} lg={4} className="company-infosys">
                                <div className="info-card" onClick={() => navigate("/digital-transformation")} style={{ cursor: "pointer" }}>
                                    <img src="images/digi.jpg" alt="Service 3" />
                                    <div className="info-card-text">
                                        {/* <h6>Our customers</h6> */}
                                        <h3>Digital <br/> Transformation</h3>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Container>
                    {/* Footer Section */}

                </section>
                {/* <section className="info-footer">
                    <Container>
                        <p>
                            Stop wasting time and money on technology.{" "}
                            <a href="#explore">Explore our company</a>
                        </p>
                    </Container>
                </section> */}
            </div>

        </>
    )
}